import { render, staticRenderFns } from "./ReportPictureDetailsForm.vue?vue&type=template&id=528ad2a8&scoped=true&"
import script from "./ReportPictureDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./ReportPictureDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPictureDetailsForm.vue?vue&type=style&index=0&id=528ad2a8&lang=scss&scoped=true&"
import style1 from "./ReportPictureDetailsForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ad2a8",
  null
  
)

export default component.exports